module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/expand-arrows-dc1501ff6de499e58f2663cd54077f3e.svg";